import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette } from '../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    btn: {
      borderRadius: '999em',
      lineHeight: 1,
      fontWeight: 'bold',
      boxShadow: `0px 3px 6px ${colorsPalette.black}`,
      textDecoration: 'none',
      fontSize: 16,
      minWidth: 150,
    },
    btnOutlined: {
      padding: '16px 32px',
      borderWidth: 3,
      borderStyle: 'solid',
      [theme.breakpoints.up('md')]: {
        padding: '12px 29px',
      },
      '&:hover': {
        borderWidth: 3,
      },
    },
    btnContained: {
      border: 'none',
      padding: '19px 35px',
      [theme.breakpoints.up('md')]: {
        padding: '15px 32px',
      },
    },
    btnOutlinedPrimary: {
      color: colorsPalette.white,
      borderColor: theme.palette.primary.light,
      '&:hover': {
        background: theme.palette.primary.light,
        color: 'rgba(0, 0, 0, 0.87)',
      },
      '&$btnDisabled': {
        border: '3px solid rgba(255, 255, 255, 0.33)',
        color: 'rgba(255, 255, 255, 0.33)',

        '& > *': {
          opacity: 0.3,
        },
      },
    },
    btnOutlinedSecondary: {
      color: colorsPalette.white,
      borderColor: colorsPalette.gray,
      '&:hover': {
        background: colorsPalette.gray,
        borderColor: colorsPalette.gray,
        color: 'rgba(0, 0, 0, 0.87)',
      },
      '&$btnDisabled': {
        border: '3px solid rgba(255, 255, 255, 0.33)',
        color: 'rgba(255, 255, 255, 0.33)',

        '& > *': {
          opacity: 0.3,
        },
      },
    },
    btnContainedPrimary: {
      color: colorsPalette.blackPure,
      '&:hover': {
        opacity: 0.9,
      },
    },
    btnContainedSecondary: {
      background: 'rgba(255, 255, 255, 0.203922)',
      '&:hover': {
        background: 'rgba(255, 255, 255, 0.08)',
      },
    },
    btnDisabled: {},
  }),
);

export default useStyles;
